export default "__VITE_ASSET__ksq3CK$U__"